/**
 * Russian (Russia) locale settings for Webix.
 */
webix.i18n.locales['ru-RU'] = {
    groupDelimiter: ' ', // Delimiter for groups of thousands
    groupSize: 3, // Size of groups of thousands
    decimalDelimiter: ',', // Delimiter for decimal part
    decimalSize: 2, // Number of decimal places

    dateFormat: '%d.%m.%Y', // Date format
    timeFormat: '%H:%i', // Time format
    longDateFormat: '%d %F %Y', // Long date format
    fullDateFormat: '%d.%m.%Y %H:%i', // Full date and time format

    price: '{obj} руб.', // Price format
    priceSettings: null, // Use number defaults

    calendar: {
        monthFull: [
            'Январь',
            'Февраль',
            'Март',
            'Апрель',
            'Май',
            'Июнь',
            'Июль',
            'Август',
            'Сентябрь',
            'Октябрь',
            'Ноябрь',
            'Декабрь',
        ], // Full names of months
        monthShort: ['Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн', 'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'], // Short names of months
        dayFull: ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'], // Full names of days
        dayShort: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'], // Short names of days
        hours: 'Часы', // Label for hours
        minutes: 'Минуты', // Label for minutes
        done: 'Готово', // Label for done button
        clear: 'Очистить', // Label for clear button
        today: 'Сегодня', // Label for today button
    },

    dataExport: {
        page: 'Страница', // Label for page
        of: 'из', // Label for of
    },
    PDFviewer: {
        of: 'из', // Label for of
        automaticZoom: 'Автоматический зум', // Label for automatic zoom
        actualSize: 'Настоящий размер', // Label for actual size
        pageFit: 'Размер страницы', // Label for page fit
        pageWidth: 'Ширина страницы', // Label for page width
        pageHeight: 'Высота страницы', // Label for page height
    },
    aria: {
        calendar: 'Календарь', // ARIA label for calendar
        increaseValue: 'Увеличить значение', // ARIA label for increase value
        decreaseValue: 'Уменьшить значение', // ARIA label for decrease value
        navMonth: ['Предыдущий месяц', 'Следующий месяц'], // ARIA labels for navigating months
        navYear: ['Предыдущий год', 'Следующий год'], // ARIA labels for navigating years
        navDecade: ['Предыдущие десять лет', 'Следующие десять лет'], // ARIA labels for navigating decades
        dateFormat: '%d %F %Y', // ARIA date format
        monthFormat: '%F %Y', // ARIA month format
        yearFormat: '%Y', // ARIA year format
        hourFormat: 'Часы: %H', // ARIA hour format
        minuteFormat: 'Минуты: %i', // ARIA minute format
        removeItem: 'Удалить элемент', // ARIA label for removing item
        pages: ['Первая страница', 'Предыдущая страница', 'Следующая страница', 'Последняя страница'], // ARIA labels for pages
        page: 'Страница', // ARIA label for page
        headermenu: 'Меню шапки таблицы', // ARIA label for header menu
        openGroup: 'Развернуть группу столбцов', // ARIA label for opening column group
        closeGroup: 'Свернуть группу столбцов', // ARIA label for closing column group
        closeTab: 'Закрыть вкладку', // ARIA label for closing tab
        showTabs: 'Показать больше вкладок', // ARIA label for showing more tabs
        resetTreeMap: 'Вернуться к первоначальному представлению', // ARIA label for resetting tree map
        navTreeMap: 'Перейти на уровень выше', // ARIA label for navigating tree map
        nextTab: 'Следующая вкладка', // ARIA label for next tab
        prevTab: 'Предыдущая вкладка', // ARIA label for previous tab
        multitextSection: 'Добавить элемент', // ARIA label for adding element
        multitextextraSection: 'Удалить элемент', // ARIA label for removing element
        showChart: 'Показать чарт', // ARIA label for showing chart
        hideChart: 'Спрятать чарт', // ARIA label for hiding chart
        resizeChart: 'Изменить размер чарта', // ARIA label for resizing chart
    },
    richtext: {
        underline: 'Подчеркивание', // Label for underline
        bold: 'Жирный', // Label for bold
        italic: 'Курсив', // Label for italic
    },
    combo: {
        select: 'Выбрать', // Label for select
        selectAll: 'Выбрать все', // Label for select all
        unselectAll: 'Сброс выбора', // Label for unselect all
    },
};

// FILE DOCUMENTED
